"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var mobileStylesHelper_1 = __importDefault(require("../assets/mobileStylesHelper"));

var PORTAL_HEADER_HEIGHT = 30;

exports.styles = function (_a) {
  var depth3 = _a.depth3,
      colorBg = _a.colorBg,
      colorTrueBlack = _a.colorTrueBlack,
      sizeBorderRadiusPaper = _a.sizeBorderRadiusPaper,
      x2 = _a.x2,
      x4 = _a.x4;
  return __assign({
    background: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      opacity: 0.48,
      background: colorTrueBlack.normal,
      zIndex: -1
    },
    wrapper: {
      position: 'relative',
      borderRadius: sizeBorderRadiusPaper,
      outline: 'none',
      boxShadow: depth3,
      background: colorBg.normal,
      '-ms-overflow-style': 'scrollbar',
      overflowY: 'auto',
      overflowX: 'hidden',
      margin: x2,
      maxHeight: "calc(100% - " + x4 + "px)",
      zIndex: 1,
      '-ms-flex': '0 1 auto',
      '&$portalHeaderMode': {
        marginTop: x2 + PORTAL_HEADER_HEIGHT,
        maxHeight: "calc(100% - " + (x4 + PORTAL_HEADER_HEIGHT) + "px)"
      }
    },
    flexContainer: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10000,
      background: 'transparent',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      outline: 'none',
      fallbacks: [{
        display: '-ms-flexbox',
        '-ms-flex-pack': 'center',
        '-ms-flex-align': 'center'
      }]
    },
    container: {
      overflow: 'hidden'
    },
    overflowVisible: {
      overflowX: 'visible',
      overflowY: 'visible'
    },
    overflowVisibleDesktop: {
      overflowX: 'visible',
      overflowY: 'visible'
    },
    overflowVisibleMobile: {},
    portalHeaderMode: {}
  }, mobileStylesHelper_1.default({
    '-webkit-overflow-scrolling': 'touch !important',
    '&$overflowVisibleMobile': {
      overflowX: 'visible',
      overflowY: 'visible'
    },
    '&$overflowVisibleDesktop': {
      overflowY: 'auto',
      overflowX: 'hidden'
    }
  }));
};